import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { searchMentions, type MentionOption, type MentionTab } from '@/lib/api/assistantMentions';

// Search-as-you-type for the Ruta AI @-mention picker. Org-wide, per tab.
export function useAssistantMentions(tab: MentionTab, query: string, enabled: boolean) {
  return useQuery<MentionOption[]>({
    queryKey: ['assistant-mentions', tab, query],
    queryFn: () => searchMentions(tab, query),
    enabled,
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}
